import React, { useEffect, useState } from 'react';

function uid() {
  return Math.random().toString(36).slice(2, 9);
}

export default function AddAppModal({ open, onClose, onAdd, onUpdate, editing }) {
  const [title, setTitle] = useState('');
  const [url, setUrl] = useState('');
  const [description, setDescription] = useState('');
  const [icon, setIcon] = useState('');

  useEffect(() => {
    if (editing) {
      setTitle(editing.title || editing.name || '');
      setUrl(editing.url || '');
      setIcon(editing.icon || '');
      setDescription(editing.description || '');
    } else {
      setTitle(''); setUrl(''); setIcon(''); setDescription('');
    }
  }, [editing, open]);

  if (!open) return null;

  function submit(e) {
    e.preventDefault();
    const payload = {
      id: editing?.id || uid(),
      title: title || url,
      url: url.startsWith('http') ? url : `https://${url}`,
      icon: icon || '',
      description: description || ''
    };
    if (editing) onUpdate(payload); else onAdd(payload);
  }

  return (
    <div className="modal-backdrop" onMouseDown={onClose}>
      <form className="modal" onSubmit={submit} onMouseDown={e => e.stopPropagation()}>
        <h3>{editing ? 'Modifier l\u2019application' : 'Ajouter une application'}</h3>
        <label>Nom</label>
        <input value={title} onChange={e => setTitle(e.target.value)} placeholder="Ex: Heimdall" />
        <label>URL</label>
        <input value={url} onChange={e => setUrl(e.target.value)} placeholder="exemple.com or https://exemple.com" />
        <label>Description (facultatif)</label>
        <input value={description} onChange={e => setDescription(e.target.value)} placeholder="Courte description" />
        <label>Icone (URL facultative)</label>
        <input value={icon} onChange={e => setIcon(e.target.value)} placeholder="https://.../icon.png" />
        <div className="modal-actions">
          <button type="button" className="btn" onClick={onClose}>Annuler</button>
          <button type="submit" className="btn primary">{editing ? 'Sauvegarder' : 'Ajouter'}</button>
        </div>
      </form>
    </div>
  );
}
